export {};

declare global {
  interface Date {
    getEndDateInMonth(): Date;
    format(): String;
  }
}

/**
 * 날짜가 포함된 월의 마지막 날짜를 계산한다.
 */

Date.prototype.getEndDateInMonth = function (): Date {
  return new Date(this.getFullYear(), this.getMonth() + 1, 0);
};

Date.prototype.format = function (): String {
  return formatDate(this);
};

export function padTo2Digits(num: number) {
  return num.toString().padStart(2, "0");
}

function formatDate(date: Date) {
  return [date.getFullYear(), padTo2Digits(date.getMonth() + 1), padTo2Digits(date.getDate())].join(
    "-"
  );
}
